import React, { useState } from "react"

import { Modal } from "../components/daisy"
import { ModalContext } from "./ModalContext"

interface ModalProviderProps {
  children: React.ReactNode
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalContent, setModalContent] = useState<React.ReactNode>(null)
  const [modalClassName, setModalClassName] = useState<string>('');

  const openModal = (content: React.ReactNode, className?: string) => {
    setModalContent(content)
    setIsModalOpen(true)
    setModalClassName(className || '');
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setModalContent(null)
  }


  return (
    <ModalContext.Provider value={{ isModalOpen, openModal, closeModal }}>
      {children}
      {isModalOpen && (
        <Modal
          open={isModalOpen}
          onClose={() => closeModal()}
          className={modalClassName}
        >
          {modalContent}
        </Modal>
      )}
    </ModalContext.Provider>
  )
}
